export default "__VITE_ASSET__a10356fb__"